import { parse } from "date-fns";
import type { DateInterval } from "../../common/types/deliveryTypes";
import type { DSPOrderList, M3OrderListed, OrderFilter } from "../../common/types/m3Types";
import { fetchDSPOrderList } from "../orders/orderUtilsAndApi";

export type M3OrderWithParsedDeliveryDate = M3OrderListed & {
   parsedDeliveryDate: Date | null;
};
export type DSPOrderWithParsedDeliveryDate = DSPOrderList & {
   parsedDeliveryDate: Date | null;
};

export const fetchOrdersForDeliveryInterval = async (
   interval: DateInterval,
   m3CompanyNumber: string,
   m3CustomerNumber: string
): Promise<DSPOrderWithParsedDeliveryDate[]> => {
   const filter: OrderFilter = {
      orderNumber: "",
      orderName: "",
      dateRange: interval,
      status: ""
   };
   const orders = await fetchDSPOrderList(m3CompanyNumber, m3CustomerNumber, filter);

   return orders
      .filter((order) => {
         const { deliveryDate, orderType, isTemporaryOrder } = order;
         if (!deliveryDate || orderType !== "WEB" || isTemporaryOrder) {
            return false;
         }
         return true;
      })
      .map((order) => {
         let parsedDeliveryDate: Date | null = order.deliveryDate ? parse(order.deliveryDate, "yyyyMMdd", new Date()) : null;
         if (!parsedDeliveryDate || Number.isNaN(parsedDeliveryDate.getTime())) {
            parsedDeliveryDate = null;
         }

         return {
            ...order,
            parsedDeliveryDate
         };
      })
      .sort((a, b) =>
         a.parsedDeliveryDate === null
            ? 1
            : b.parsedDeliveryDate === null
              ? -1
              : a.parsedDeliveryDate.getTime() - b.parsedDeliveryDate.getTime()
      );
};
